<template>
    <div class="header-element">
        {{title}}
    </div>
</template>
<script>
export default {
    props: ['title']
}
</script>
<style scoped>

</style>
